import { render } from "./FormularioEditar.vue?vue&type=template&id=1ee4cc13"
import script from "./FormularioEditar.vue?vue&type=script&lang=js"
export * from "./FormularioEditar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__